module.exports = __webpack_public_path__ + "assets/img/sclq.77ea053c.png";